import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { possibleResumeHostingForBotIdSelector } from '../selectors'

export function usePossibleResumeHostingForBotId(botId: string) {
  return useSelector<RootState, boolean | undefined>(state =>
    possibleResumeHostingForBotIdSelector(state, botId)
  )
}
